import { Link } from 'gatsby'
import React, { FunctionComponent } from 'react'

interface CourseCardProps {
  title: string
  subtitle?: string
  videos: string | number
  thumbnail: string
  duration: string
  link: string
  dataTestid?: string
}

const CourseCardStack: FunctionComponent<CourseCardProps> = (props) => {
  const {
    title,
    subtitle,
    videos,
    duration,
    thumbnail,
    link,
    dataTestid = 'course-card',
  } = props || {}

  const imgSrc =
    thumbnail ||
    'https://www.paypalobjects.com/docsvideoassets/course-thumbnail.svg'

  return (
    <Link to={link} className="courseCard-wrapper" data-testid={dataTestid}>
      <div className="courseCardStack-thumbail-wrapper">
        <div style={{ position: 'absolute', width: '90%', top: -20 }}>
          <img
            src={imgSrc}
            alt="video-thumbnail"
            className="courseCard-thumbnail"
            data-testid="video-thumbnail-id"
          />
        </div>
        <div style={{ position: 'absolute', width: '95%', top: -10 }}>
          <img
            src={imgSrc}
            alt="video-thumbnail"
            className="courseCard-thumbnail"
          />
        </div>
        <div style={{ width: '100%', position: 'absolute' }}>
          <img
            src={imgSrc}
            alt="video-thumbnail"
            className="courseCard-thumbnail"
          />
        </div>
      </div>
      <div className="courseCardStack-content">
        <p className="courseCard-duration" data-testid="video-duration">
          {duration}
        </p>
        <h1 className="courseCard-title" data-testid="video-title">
          {title}
        </h1>
        {subtitle && <p className="courseCard-subtitle">{subtitle}</p>}
        <p className="courseCard-description" data-testid="videos-count">
          {videos} videos
        </p>
      </div>
    </Link>
  )
}

export default CourseCardStack
